export const INDUSTRIES = [
  'General',
  'Arts',
  'Business',
  'Engineering',
  'Finance',
  'Law',
  'Medicine',
  'Science'
];
